import axios from 'axios';

import { downloadBlob } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { AppThunkDispatch } from 'data/store';
import { errorHandler } from '../../services/axiosService';
import { TaxDocument } from '../models/taxDocuments';

export const fetchTaxDocumentsByYearAndQid = async (taxYear: number, qid: string, dispatch?: AppThunkDispatch): Promise<TaxDocument[]> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/tax/${taxYear}/${qid}`);
    return response.data;
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, 'API Error: Failed Fetching Tax Documents')(e);
    }
    return [];
  }
};

export const fetchTaxDocumentFile = async (taxDocument: TaxDocument, dispatch?: AppThunkDispatch): Promise<void> => {
  try {
    if (!taxDocument.s3Filename) {
      throw new Error('Value Error: Missing file location for tax document.');
    }

    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/tax/doc/${taxDocument.s3Filename}/${taxDocument.documentName}`, {
      responseType: 'blob' as const,
    });

    const blobUrl = window.URL.createObjectURL(response.data);

    downloadBlob(blobUrl, `${taxDocument.documentName}.pdf`);
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, `API Error: Failed to download tax document ${taxDocument.document}`)(e);
    }
  }
};
